import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppModuleShared } from './app.module.shared';
import { AppComponent } from './components/app/app.component';

@NgModule({
    imports: [
        BrowserModule,
        AppModuleShared
    ],
    providers: [
        { provide: 'BASE_URL', useFactory: getBaseUrl },
        { provide: 'LOCAL_URL', useFactory: getLocalUrl }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}

export function getLocalUrl() {
    return document.getElementsByTagName('base')[0].href;
}

export function getBaseUrl() {
    var thisUrl: string = window.location.href;
    thisUrl = thisUrl.replace("http://", "");
    thisUrl = thisUrl.replace("https://", "");
    thisUrl = thisUrl.substring(0, thisUrl.indexOf("/"));
    console.log("thisUrl", thisUrl);

    var prodUrls: string[] = [
        "white-wave-0950b4910.centralus.4.azurestaticapps.net",
        "alsepicenterportal.epilutions.com",
        "epicenterportal.epilutions.com"
    ];
    var stagingUrls: string[] = [
        "white-wave-0950b4910-staging.centralus.4.azurestaticapps.net",
        "alsepicenterportal-staging.epilutions.com",
        "epicenterportal-staging.epilutions.com"
    ];
    var testUrls: string[] = [
        "white-wave-0950b4910-test.centralus.4.azurestaticapps.net",
        "alsepicenterportal-test.epilutions.com",
        "epicenterportal-test.epilutions.com"
    ];
    var previewUrls: string[] = [
        "white-wave-0950b4910-preview.centralus.3.azurestaticapps.net"
    ];
    var devUrls: string[] = [
        "localhost:4200"
    ];

    var baseUrl: string = "https://epilutionswebportal.azurewebsites.net";

    if (prodUrls.indexOf(thisUrl) >= 0) {
        console.log("Environment: PROD");
        baseUrl = "https://epilutionswebportal.azurewebsites.net";
    }
    else if (stagingUrls.indexOf(thisUrl) >= 0) {
        console.log("Environment: STAGING");
        baseUrl = "https://epilutionswebportal-staging.azurewebsites.net";
    }
    else if (testUrls.indexOf(thisUrl) >= 0) {
        console.log("Environment: TEST");
        baseUrl = "https://epilutionswebportal-test.azurewebsites.net";
    }
    //else if (previewUrls.indexOf(thisUrl) >= 0) {
    //    console.log("Environment: PREVIEW");
    //    baseUrl = "https://epicenterexternalportalapi-test.azurewebsites.net";
    //}
    else if (devUrls.indexOf(thisUrl) >= 0) {
        console.log("Environment: DEV");
        baseUrl = "https://localhost:44300";
    }
    else {
        // Default PROD
        console.log("Environment: PROD");
        baseUrl = "https://epilutionswebportal.azurewebsites.net";
    }

    baseUrl += "/";

    console.log("BaseUrl", baseUrl);
    return baseUrl;
}
